export { default, initialize } from 'ember-model-validator/initializers/register-version';
